const BASE = 'https://app.colokial.co/api/';
const UPLOAD_FILE = 'https://app.colokial.co/node/';
const REPORTS = `https://middleware.prod.colokial.co/colokial/rest/reportes/`;
const socketIO = 'https://app.colokial.co'
export default {
    APP_NAME: 'Colokial',
    GOOGLE_RECAPTCHA: '6LdVG3sUAAAAAGvp8ECNh0enfcdcwLt5zC-s58rT',
    APP_USER: 'pablo.esquivel',
    APP_PASSWORD: 'Iteria123',
    APP: 2, // CODIGO DE LA APLICACION COLOKIAL
    URL_FUSION: 'https://eeio.fa.us2.oraclecloud.com',
    URL_FOLDER: '/home/load_data/',
    SERVER_NAME_FTP: 'FTP_COLOKIAL_PRD',
    API: {
        load_journals: BASE + 'load_journals',
        upload_file: UPLOAD_FILE + 'upload_file',
        get_movement: BASE + 'get_movement',
        threshold: BASE + 'threshold',
        update_mg_media: BASE + 'update_mg_media',
        generate_xml: BASE + 'generate_xml',
        validate_third_party: UPLOAD_FILE + 'validate_third_party',
        get_ledger_DOEQ: BASE + 'get_ledger_DOEQ',
        get_legal_entity_DOEQ: BASE + 'get_legal_entity_DOEQ',
        get_providers_DOEQ: BASE + 'get_providers_DOEQ',
        validate_movement_year: BASE + 'validate_movement_year',
        validate_literal_rank: BASE + 'validate_literal_rank',
        validate_topes: BASE + 'validate_topes',
        validate_gen_magnetic: BASE + 'validate_gen_magnetic_media',
        validate_generate_xml_files: BASE + 'validate_generate_xml_files',
        get_months: BASE + 'get_months',
        get_literals: BASE + 'get_literals',
        get_formats: BASE + 'get_formats',
        validate_journal: BASE + 'validate_journal',
        validate_third_errors: BASE + 'validate_third_errors',
        validate_errors: BASE + 'validate_errors',
        consult_third: BASE + 'consult_third',
        create_trx_balance: BASE + 'create_trx_balance',
        periods: BASE + 'periods',
        load_tables: BASE + 'load_tables',
        edit_third: BASE + 'edit_third',
        get_city: BASE + 'get_city',
        get_periods: BASE + 'get_periods',
        compare_balance: BASE + 'compare_balance',
        get_lookups_types: BASE + 'get_lookups_types',
        lookups_types: BASE + 'lookups_types',
        get_lookups_values: BASE + 'get_lookups_values',
        get_reports_values: BASE + 'get_reports_values',
        lookups_values: BASE + 'lookups_values',
        get_report_by_nit: BASE + 'get_report_by_nit',
        ranges: BASE + 'ranges',
        get_balance_third_acum: BASE + 'get_balance_third_acum',
        get_formats_literals: BASE + 'get_formats_literals',
        get_ledger: BASE + 'get_ledger',
        get_legal_entity: BASE + 'get_legal_entity',
        get_year: BASE + 'get_year',
        ledgers: BASE + 'ledgers',
        get_period_year: BASE + 'get_period_year',
        formats: BASE + 'formats',
        segments: BASE + 'segments',
        get_segments: BASE + 'get_segments',
        consult_legal_entity: BASE + 'consult_legal_entity',
        edit_legal_entity: BASE + 'edit_legal_entity',
        load_journals_ws: BASE + 'load_journals_ws',
        load_third_party_ws: BASE + 'load_third_party_ws',
        validate_third_party_ws: BASE + 'validate_third_party_ws',
        compare_balance_ws: BASE + 'compare_balance_ws',
        get_literals_by: BASE + 'get_literals_by',
        consult_formats: BASE + 'consult_formats',
        edit_literals: BASE + 'edit_literals',
        get_format_by_ledger: BASE + 'get_format_by_ledger',
        get_mg_configs: BASE + 'get_mg_configs',
        value_informed: BASE + 'value_informed',
        get_report_ws: BASE + 'get_report_ws',
        segments_by_ledger_id: BASE + 'segments_by_ledger_id',
        get_ledger_year: BASE + 'get_ledger_year',
        get_ledger_year_literals: BASE + 'get_ledger_year_literals',
        get_ledger_format: BASE + 'get_ledger_format',
        rep_concepts_range: BASE + 'rep_concepts_range',
        rep_format_concepts: BASE + 'rep_format_concepts',
        create_lookups_values: BASE + 'create_lookups_values',
        get_literals_third: BASE + 'get_literals_third',
        alert_create_balance: BASE + 'alert_create_balance',
        consult_state: BASE + 'consult_state',
        get_country: BASE + 'get_country',
        get_activity: BASE + 'get_activity',
        year_by_ledger: BASE + 'year_by_ledger',
        get_periods_coding: BASE + 'get_periods_coding',
        get_xml_formats: BASE + 'get_xml_formats',
        compare_balance_det: BASE + 'compare_balance_det',
        get_document_type: BASE + 'get_document_type',
        get_nature: BASE + 'get_nature',
        get_status: BASE + 'get_status',
        get_currency: BASE + 'get_currency',
        get_process: BASE + 'get_process',
        create_format: BASE + 'create_format',
        formats_cols: BASE + 'formats_cols',
        get_sequence: BASE + 'get_sequence',
        load_third_party: BASE + 'load_third_party',
        load_process: BASE + 'load_process',
        get_process_detail: BASE + 'get_process_detail',
        get_log_process: BASE + 'get_log_process',
        update_process: BASE + 'update_process',
        f_validate_third_party: BASE + 'f_validate_third_party',
        f_get_book_year: BASE + 'f_get_book_year',
        get_concept: BASE + 'get_concept',
        f_get_format_concept: BASE + 'f_get_format_concept',
        f_get_thirdparty_years: BASE + 'f_get_thirdparty_years',
        f_rep_thirdparty: BASE + 'f_rep_thirdparty',
        f_get_literals: BASE + 'f_get_literals',
        validate_third_information: BASE + 'validate_third_information',
        f_rep_lit_account: BASE + 'f_rep_lit_account',
        download_file: UPLOAD_FILE + 'download_file',
        compare_balance_det_ws: BASE + 'compare_balance_det_ws',
        get_task_id: BASE + 'get_task_id',
        f_get_process_id: BASE + 'f_get_process_id',
        f_table_summary_bal: BASE + 'f_table_summary_bal',
        get_wsdl_app: BASE + 'get_wsdl_app',
        f_update_jobs_id: BASE + 'f_update_jobs_id',
        f_get_exist_xml: BASE + 'f_get_exist_xml',
        load_journals_third: BASE + 'load_journals_third',
        get_data_loaded: BASE + 'get_data_loaded',
        bridge_soap: BASE + 'bridge_soap',
        generate_media_automatic: BASE + 'generate_media_automatic',
        f_get_journal_year: BASE + 'f_get_journal_year',
        revoke_task: BASE + 'revoke_task',
        get_exist_nits: BASE + 'get_exist_nits',
        get_schema: BASE + 'get_schema',
        get_system_tables: BASE + 'get_system_tables',
        f_format_copy: BASE + 'f_format_copy',
        f_literal_copy: BASE + 'f_literal_copy',
        load_periods_ws: BASE + 'load_periods_ws',
        f_rep_validation_xml: BASE + 'get_report_validation_xml',
        logoutForce: BASE + 'logout_force',
        save_task_scheduler: BASE + 'schedule/create-schedule',
        schedule_create_email: BASE + 'schedule/create-email',
        schedule_remove_email: BASE + 'schedule/remove-email',
        schedule_get_app: BASE + 'schedule/searchs-app',
        massive_update: BASE + 'massive_update',
        get_process_tercero: BASE + 'get_process_tercero',
        get_process_tercero_datail: BASE + 'get_process_tercero_datail',
        process_terc: BASE + 'process_terc',
        revoke_task_celery: BASE + 'revoke_task_celery',
        lovs_ws: BASE + 'lovs_ws',
        get_lookup_values_DOEQ: BASE + 'get_lookup_values_DOEQ',
        get_sequence_process: BASE + 'get_sequence_process',
        process_DOEQ: BASE + 'process_DOEQ',
        get_proccess_DOEQ: BASE + 'get_proccess_DOEQ',
        get_file_name: BASE + 'get_file_name',
        automatic_file_upload: BASE + 'automatic_file_upload',
        automatic_generation: BASE + 'automatic_generation',
        get_support_docu: BASE + 'get_support_docu',
        generate_report: BASE + 'generate_report',
        generate_consecutive: BASE + 'generate_consecutive',
        get_info_reports: BASE + 'get_info_reports',
        get_report_fact: BASE + 'get_report_fact',
        update_process_status: BASE + 'update_process_status',
        lookups_type_doeq: BASE + 'lookups_type_doeq',
        lookups_values_doeq: BASE + 'lookups_values_doeq',
        create_lookups_values_doeq: BASE + 'create_lookups_values_doeq',
        rep_doc_support: BASE + 'rep_doc_support',
        loockup_value_view: BASE + 'loockup_value_view',
        massive_update_providerdoeq: BASE + 'massive_update_providerdoeq',
        get_process_tercero_doeq: BASE + 'get_process_tercero_doeq',
        process_terc_doeq: BASE + 'process_terc_doeq',
        revoke_task_celery_doeq: BASE + 'revoke_task_celery_doeq',
        article_save: BASE + 'article_save',
        years_article: BASE + 'years_article',
        article_detail: BASE + 'article_detail',
        article_detail_delete: BASE + 'article_detail_delete',
        article_value: BASE + 'article_value',
        article_value_delete: BASE + 'article_value_delete',
        article_range: BASE + 'article_range',
        article_range_delete: BASE + 'article_range_delete',
        genertation_media_district: BASE + 'genertation_media_district',
        genertation_article_csv: BASE + 'genertation_article_csv',
        validation_acount_third: BASE + 'validation_acount_third',
        generation_file: BASE + 'generation_file',
        f_article_copy: BASE + 'f_article_copy',
        get_filename: BASE + 'get_filename',
        get_document: BASE + 'get_document',
        automatic_generation_dat: BASE + 'automatic_generation_dat',
        report_article_details: BASE + 'report_article_details',
        get_process_support_docu: BASE + 'get_process_support_docu',
        generation_document: BASE + 'generation_document',
        get_settings_resolution: BASE + 'get_settings_resolution',
        settings_resolution: BASE + 'settings_resolution',
        process_fnd: BASE + 'process-fnd',
        merge_ledgers: BASE + 'merge_ledgers',
        get_operating_unit_by_ledger: BASE + 'get_operating_unit_by_ledger',
        save_gl_user_ou: BASE + 'save_gl_user_ou',
        get_clientes_cr: BASE + 'get_clientes_cr',
        setChangeCompany: BASE + 'setChangeCompany',
        get_payload_getdata: BASE + 'get_payload_getdata',
        consult_resumen : BASE + 'consult_resume',
        get_resume: BASE + 'get_resume',
        save_pruchase: BASE + 'save_pruchase',
        active_identification: BASE + 'active_identification',
        active_location: BASE + 'active_location',
        active_purchase: BASE + 'active_purchase',
        active_registration: BASE + 'active_registration',
        active_maintenance: BASE + 'active_maintenance',
        run_report_periods: BASE + 'run-report-periods',
        services_third : BASE + 'services-third',
        set_jobs_process : BASE + 'set-jobs-proccess',
        cancel_task_balance : BASE + 'cancel-task-balance',
        run_report_compare_balance : BASE + 'run-report-compare-balance',
        remove_task_scheduler: BASE + 'schedule/remove-schedule',
        agencies : BASE + 'agencies', 
        bulk_load : BASE + 'bulk-load',
        report_assets: BASE + 'report-assets',
        report_maintenance : BASE + 'report_maintenance',
        get_template: BASE + 'get-template',
        get_template_inv: BASE + 'get-inventory',
        get_employe : BASE + 'get-employee',
        get_asset_report : BASE + 'get-asset-report',
        generate_bulk_file : BASE + 'generate-large-file',
        get_assets_report: BASE + 'get-assets-report',
        get_center_cost : BASE + 'get-center-cost',
        get_locations_center_cost : BASE + 'locations-center-cost',
        load_locations: BASE + 'load-locations',
        get_locations: BASE + 'get-locations',
        save_location: BASE + 'save-locations',
        save_employees: BASE + 'save-employee',
        get_asset_file: BASE + 'get-asset-file',
        location_lookup : BASE + "location-lookup",
        del_asset_file : BASE + 'del-asset-file',
        asset_lookup_value :BASE + 'asset-lookup-value',
        view_tip_doc_resolution : BASE + 'view_tip_doc_resolution',
        view_cla_tec_resolution : BASE + 'view_cla_tec_resolution',
        get_suppliers: BASE + 'rxsup/get-suppliers',
        get_orderinvoice: BASE + 'rxsup/get-order-invoice',
        report_invoices: BASE + 'rxsup/report-invoice',
        get_priority: BASE + 'tickets/get-priority',
        create_ticket: BASE + 'tickets/create-ticket',
        get_statustkt: BASE + 'tickets/get-status',
        query_tickets: BASE + 'tickets/query-tickets',
        detail_tickets: BASE + 'tickets/detail',
        get_files_process : BASE + 'get-files-process',
        balance_third_ica : BASE + 'balance-third-ica',
        balance_third_iva : BASE + 'balance-third-iva',
        balance_third_rtica : BASE + 'balance-third-rtica',
        balance_third_rtf : BASE + 'balance-third-rtf',
        params_nav_accounting : BASE + 'accounting/params-nav-accounting',
        get_lookups_types_radoeq: BASE + 'get_lookups_types_radoeq',
        get_lookups_values_radoeq: BASE + 'get_lookups_values_radoeq',
        create_lookups_values_radoeq: BASE + 'create_lookups_values_radoeq',
        lookups_values_radoeq: BASE + 'lookups_values_radoeq',
        lookups_types_radoeq: BASE + 'lookups_types_radoeq',
        get_rules: BASE + 'get_rules',
        get_areas: BASE + 'get_areas',
        get_rules_documents: BASE + 'get_rules_documents',
        create_rules_documents: BASE + 'create_rules_documents',
        update_rules_documents: BASE + 'update_rules_documents',
        delete_rules_documents: BASE + 'delete_rules_documents',
        consult_advanced : BASE + 'consult_advanced',
        report_radoeq: BASE + 'report_radoeq',
        get_rules_doc : BASE + 'get_doc_rules',
        manage_order : BASE + 'manage_order',
        rxnsp_order_status : BASE + 'rxnsp-order-status',
        get_consecutive : BASE + 'get_consecutive',
        get_lookups_values_radoeq_active: BASE + 'get_lookups_values_radoeq_active',
        delete_order_file : BASE + 'delete-order-file',
        notify_invoice_rxnsp : BASE + 'notify-invoice-rxnsp',
        balance_third_ica : BASE + 'balance-third-ica',
        balance_third_iva : BASE + 'balance-third-iva',
        balance_third_rtica : BASE + 'balance-third-rtica',
        balance_third_rtf : BASE + 'balance-third-rtf',
        params_nav_accounting : BASE + 'accounting/params-nav-accounting',
        template_bulk_assets : BASE + 'template-bulk-assets',
        fields_locations : BASE + 'fields-locations',
        locations_responsible_headerscsv : BASE + 'locations-responsible-headers-csv',
        get_employees_status: BASE + 'employees-status',
        dependencies: BASE + 'dependencies',
        cvfa_permissions: BASE + 'cvfa/permission',
        base : BASE,
        balance_third_ica : BASE + 'balance-third-ica',
        balance_third_iva : BASE + 'balance-third-iva',
        balance_third_rtica : BASE + 'balance-third-rtica',
        balance_third_rtf : BASE + 'balance-third-rtf',
    },
    SOAP: {
        ReportService: 'https://eeio.fa.us2.oraclecloud.com/xmlpserver/services/v2/ReportService?wsdl',
    },
    LOGIN: {
        login: BASE + 'login',
        logout: BASE + 'logout',
        generateTokenPassword: BASE + 'recoverPassword',
        changePassword: BASE + 'changePassword',
        decrypt_session : BASE + 'decrypt-session',
    },
    REPORTS: {
        jobSocket: REPORTS + 'jobs/statusjob',
        schedule_report_ftp: REPORTS + 'schedule_report_ftp',
        cancel_jobs: REPORTS + 'jobs/canceljob/',
        websocket: socketIO
    },
    USUARIOS_CLI: {
        get_entity: BASE + 'get_entity',
        get_users: BASE +  'get_users',
        userEntity: BASE + 'userEntity',
        get_usersUp: BASE + 'get_usersUp',
        get_userUnityOp: BASE + 'userUnityOp',
    },
    NOTIFICATIONS: {
        adminotifications : BASE + 'notificaciones/admin-notificaciones',
        usernotifications : BASE + 'notificaciones/admin-notificaciones-usuario'
    },
    production: false
}



// WEBPACK FOOTER //
// src/assets/environments/app-config-UBosque.js